import { VIETMAP_FONTSTACKS } from "../config/label-fonts";

const VIETMAP_GLYPHS = /^(https:\/\/maps\.vietmap\.vn\/maps\/fonts\/)([^/]+)(\/\d+-\d+\.pbf.*)$/;

/**
 * A glyph request for a font the Vietmap server doesn't have fails, and
 * MapLibre then drops every layer of that tile (blank map). Keep only the
 * fontstacks it serves; if none is left, use Noto Sans (Bold for bold names).
 * Other URLs pass through unchanged — our own /fonts API does the same
 * fallback server-side.
 */
export function guardGlyphUrl(url: string): string {
  const m = url.match(VIETMAP_GLYPHS);
  if (!m) return url;
  let stacks: string[];
  try {
    stacks = decodeURIComponent(m[2]).split(",").map((s) => s.trim());
  } catch {
    return url;
  }
  const known = stacks.filter((s) => VIETMAP_FONTSTACKS.includes(s));
  if (known.length === stacks.length) return url;
  const fallback = known[0] ?? (stacks.some((s) => /bold/i.test(s)) ? "Noto Sans Bold" : "Noto Sans Regular");
  return `${m[1]}${encodeURIComponent(fallback)}${m[3]}`;
}
